import { EntityDefinition } from '../types/entity-definition.interface';
import { EventLog, EventLogLevel } from '../types/event-log.interface';

const LEVEL_I18N_OPTIONS = [
  { labelKey: 'entities.eventLog.level.info', value: EventLogLevel.INFO, icon: 'info', color: 'info' }, //'blue-200' },
  { labelKey: 'entities.eventLog.level.warning', value: EventLogLevel.WARNING, icon: 'warning', color: 'warning' }, // 'orange-100' },
  { labelKey: 'entities.eventLog.level.error', value: EventLogLevel.ERROR, icon: 'dangerous', color: 'danger' }, // 'red-100' },
];

export const eventLogDefinition: EntityDefinition<EventLog> = {
  entityType: 'EventLog',
  i18nBase: 'entities.eventLog',
  list: {
    columns: [
      { field: 'created', headerKey: 'entities.eventLog.fields.date', sortable: true, filterable: true, template: 'datetime' },
      {
        field: 'level',
        headerKey: 'entities.eventLog.fields.type',
        sortable: true,
        filterable: 'select',
        template: 'icon+text',
        class: 'min-w-[200px]',
        options: LEVEL_I18N_OPTIONS,
      },
      {
        field: 'assetId',
        headerKey: 'entities.eventLog.fields.asset',
        sortable: true,
        filterable: 'select',
        storeType: 'Asset',
        displayField: 'name',
        class: 'min-w-[400px]',
      },
      {
        field: 'title',
        headerKey: 'entities.eventLog.fields.title',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'message',
        headerKey: 'entities.eventLog.fields.message',
        sortable: true,
        filterable: true,
        template: 'routerLinkContent',
        class: 'min-w-[600px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [],
  validationRules: [],
  actionButtons: {
    parent: {
      add: false,
      edit: false,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => '',
      edit: () => '',
      delete: () => '',
    },
    buttons: {
      add: () => '',
      create: () => '',
      edit: () => '',
      delete: () => '',
    },
    // confirmDelete: () => '',
  },
  enableFiltering: true,
};
